<template>
	<div>
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col lg="6" cols="7">
					<p class="text-muted">Credit Loan Case</p>
					<h2 class="text-xl d-inline-block mb-0">Disbursement</h2>
				</b-col>
				<!-- <b-col cols="6" class="text-right">
					<el-button type="primary">View Report</el-button>
				</b-col> -->
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<DisbursementTable />
		</b-container>
	</div>
</template>
<script>
import { Button } from 'element-ui'
// import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import DisbursementTable from '@/views/CreditLoanDisbursement/DisbursementTable'

export default {
	components: {
		// RouteBreadCrumb,
		DisbursementTable,
		[Button.name]: Button,
	},
	data() {
		return {
			backButton: false,
			isTableLoading: true,
		}
	}
}
</script>